import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Inbox, UtensilsCrossed, BookOpen, FileText, Images, Image, ArrowRight } from "lucide-react";
import api from "@/lib/api";
import { PageHeader } from "@/components/admin/ui";

const CARDS = [
  ["New Enquiries", "new_enquiries", Inbox, "/admin/enquiries", "text-blue-600 bg-blue-50"],
  ["Recipes", "recipes", UtensilsCrossed, "/admin/recipes", "text-emerald-600 bg-emerald-50"],
  ["Blog Posts", "posts", BookOpen, "/admin/blog", "text-purple-600 bg-purple-50"],
  ["Pages", "pages", FileText, "/admin/pages", "text-amber-600 bg-amber-50"],
  ["Hero Slides", "slides", Images, "/admin/slides", "text-rose-600 bg-rose-50"],
  ["Media Files", "media", Image, "/admin/media", "text-teal-600 bg-teal-50"],
];

export default function Dashboard() {
  const [stats, setStats] = useState({});
  useEffect(() => { api.get("/admin/stats").then((r) => setStats(r.data)).catch(() => {}); }, []);
  return (
    <div data-testid="admin-dashboard">
      <PageHeader title="Dashboard" subtitle="Manage your website content and enquiries" />
      <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {CARDS.map(([label, key, Icon, to, color]) => (
          <Link key={key} to={to} className="bg-white rounded-2xl p-6 border border-stone-200/80 hover:shadow-md transition-all group">
            <div className="flex items-start justify-between">
              <span className={`w-11 h-11 rounded-xl flex items-center justify-center ${color}`}><Icon size={20} /></span>
              <ArrowRight className="text-stone-300 group-hover:text-emerald-600 transition-colors" size={18} />
            </div>
            <p className="text-3xl font-serif text-emerald-950 mt-4">{stats[key] ?? "—"}</p>
            <p className="text-sm text-stone-500">{label}</p>
          </Link>
        ))}
      </div>
      <div className="mt-8 bg-white rounded-2xl p-6 border border-stone-200/80">
        <h2 className="font-serif text-lg text-emerald-900 mb-3">Quick actions</h2>
        <div className="flex flex-wrap gap-3">
          <Link to="/admin/recipes" className="rounded-lg bg-emerald-800 text-amber-50 px-4 py-2 text-sm font-semibold hover:bg-emerald-900">+ New Recipe</Link>
          <Link to="/admin/blog" className="rounded-lg bg-emerald-800 text-amber-50 px-4 py-2 text-sm font-semibold hover:bg-emerald-900">+ New Blog Post</Link>
          <Link to="/admin/pages" className="rounded-lg border border-stone-300 text-emerald-900 px-4 py-2 text-sm font-semibold hover:bg-stone-100">+ New Page</Link>
          <Link to="/admin/slides" className="rounded-lg border border-stone-300 text-emerald-900 px-4 py-2 text-sm font-semibold hover:bg-stone-100">Edit Homepage Hero</Link>
        </div>
      </div>
    </div>
  );
}
